import { AbstractControl } from '@angular/forms';

export class emailValidator {
    static match(AC: AbstractControl) {
        let mail = AC.get("email").value
        let repeat = AC.get("repeatEmail").value

        if (mail !== repeat) {
            AC.get("repeatEmail").setErrors({ match: true })
        } else {
            return null;
        }
    }
}

export class PasswordValidation {
    static MatchPassword(AC: AbstractControl) {
        let password = AC.get("contrasena").value
        let confirmPassword = AC.get("repContrasena").value

        if (password !== confirmPassword) {
            AC.get("repContrasena").setErrors({ MatchPassword: true })
        } else {
            return null;
        }
    }
}